import { render, staticRenderFns } from "./MainMenuSulteng.vue?vue&type=template&id=6dcfcedc&lang=pug"
import script from "./MainMenuSulteng.vue?vue&type=script&lang=js"
export * from "./MainMenuSulteng.vue?vue&type=script&lang=js"
import style0 from "../../../assets/style/sulteng/menu-sulteng.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports